import { sendPasswordResetEmail } from "firebase/auth"
import { useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { Link } from "react-router-dom"
import { auth } from "../../firebase"

const ForgotPassword = () => {
  const [email, setEmail] = useState("")

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [messageSent, setMessageSent] = useState(false)

  const handleOnChange = (e) => {
    setEmail(e.target.value)
    setError("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      setError("")
      setLoading(true)

      await sendPasswordResetEmail(auth, email)

      setMessageSent(true)
    } catch (error) {
      console.log(error)
      setError("Failed to send reset password email. Please try again.")
    }
    setLoading(false)
  }

  return (
    <>
      <Card className="w-100 border-0 shadow" style={{ maxWidth: "400px" }}>
        <Card.Body>
          {messageSent
            ? (
              <>
                <Alert variant="success" className="m-0" style={{ borderLeft: '4px solid #4caf50' }}>A reset password email has been sent to your inbox. It may be in your junk folder.</Alert>
                <Button className="w-100 mt-4" as={Link} to="/login">
                  Go To Login
                </Button>
              </>
            )
            : (
              <>
                <h2 className="text-center mb-4">Reset Password</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                  <Form.Group id="email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" value={email} onChange={handleOnChange} required />
                  </Form.Group>
                  <Button disabled={loading} className="w-100 mt-4" type="submit">
                    Reset Password
                  </Button>
                </Form>
                <div className="w-100 text-center mt-3">
                  <Link to="/login">Login</Link>
                </div>
              </>
            )
          }
        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2">
        Not a member? <Link to="/login/create-account">Sign Up</Link>
      </div>
    </>
  )
}
export default ForgotPassword